<div class="form-modal" style="width: 75vw" *ngIf="form">
  <h1 mat-dialog-title>{{'ACCOUNTING_CONFIGURATION'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal" (keydown.enter)="$event.preventDefault()">
      <div class="form-group">
        <div *ngIf="form != null" class="table table-bordered display" cellspacing="0">
          <table>
            <thead>
              <tr>
                <th width="4%">
                  <strong>%</strong>
                </th>
                <th>
                  <strong>{{'FIXED_VALUE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionRefactor">
                  <strong>{{'REFACTOR'|translate}}</strong>
                </th>
                <th *ngIf="showRetentionCode">
                  <strong>{{'RETENTION_CODE'|translate}}</strong>
                </th>
                <th>
                  <strong>{{'COST_CENTER'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionActivityCode">
                  <strong>{{'ACTIVITY_CODE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionInitiativeCode">
                  <strong>{{'INITIATIVE_CODE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionFixedAssetRecordType">
                  <strong>{{'FIXED_ASSET_RECORD_TYPE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionAmortizationBookCode">
                  <strong>{{'AMORTIZATION_BOOK_CODE'|translate}}</strong>
                </th>
                <th *ngIf="showAccountingVatGroup">
                  <strong>{{'PRODUCT_SERVICE_CODE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionAccountingType">
                  <strong>{{'TYPE'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionExpenseAccount">
                  <strong>{{'EXPENSE_ACCOUNT_PRODUCT'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionVatTreatmentType">
                  <strong>{{'VAT_DEDUCTION_METHOD'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionVATaccountingGroup">
                  <strong>{{'VAT_ACCOUNTING_GROUP'|translate}}</strong>
                </th>
                <th *ngIf="showDistributionCodMensualizacao">
                  <strong>{{'MONTHLY_CODE'|translate}}</strong>
                </th>
                <th>
                  <strong>{{'OBS_ABBREVIATION'|translate}}</strong>
                </th>
                <th *ngIf="!isDisabled"></th>
              </tr>
            </thead>
            <tbody formArrayName="AccountingConfigList">
              <ng-container
                *ngIf="form.controls.AccountingConfigList.controls.length > 0; else noResultsCostCenterConfig">
                <tr *ngFor="let item of form.controls.AccountingConfigList.controls; let i=index" [formGroupName]="i">
                  <!-- Percentagem -->
                  <td>
                    <mat-form-field class="allwidth"
                      [ngClass]="{ 'mat-input-invalid': !form.controls.AccountingConfigList.controls[i].controls.Percentagem.errors }">
                      <input matInput formControlName="Percentagem"
                        (change)="onChangePercentage($event.target.value, i)" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <!-- Valor Fixo -->
                  <td>
                    <mat-form-field class="allwidth"
                      [ngClass]="{ 'mat-input-invalid': !form.controls.AccountingConfigList.controls[i].controls.ValorFixo.errors }">
                      <input matInput formControlName="ValorFixo" (change)="onChangeFixedValue($event.target.value, i)"
                        class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <!-- Refaturar -->
                  <td *ngIf="showDistributionRefactor" class="verticalMiddle text-center">
                    <mat-checkbox class="allwidth" formControlName="Refaturar" (change)="onChangeRefactor($event, i)">
                    </mat-checkbox>
                  </td>

                  <!-- Cod Retenção -->
                  <td *ngIf="showRetentionCode">
                    <mat-form-field class="allwidth"
                      [ngClass]="{ 'mat-input-invalid': !form.controls.AccountingConfigList.controls[i].controls.CodRetencao.errors }">
                      <input matInput formControlName="CodRetencao" class="no-padding-left">
                    </mat-form-field>
                  </td>

                  <!-- Centro de Custo -->
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput class="one" formControlName="CentroCusto">
                        <i matSuffix class="glyphicon glyphicon-new-window" style="font-size: 13px"
                          (click)="selectCostCenter(i)" *ngIf="enableSaveButton && !item.controls['CentroCusto'].disabled"></i>
                    </mat-form-field>
                  </td>

                  <!-- Cod. Atividade -->
                  <td *ngIf="showDistributionActivityCode">
                    <dropdown-selector-modal formControlName="CodAtividade"
                      [dropdownTitle]="'ACTIVITY_CODE_LIST'|translate" [DropDownID]="'ActivityCode'"
                      [editMode]="enableSaveButton" [displayCodeInsteadOfDescription]="true"
                      [dropdownList]="activityCodesList"
                      [parentCode]="item.get('ContaGasto').value">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Cod. Iniciativa -->
                  <td *ngIf="showDistributionInitiativeCode">
                    <dropdown-selector-modal formControlName="CodIniciativa"
                      [dropdownTitle]="'INITIATIVE_CODE_LIST'|translate" [DropDownID]="'InitiativeCode'"
                      [editMode]="enableSaveButton" [displayCodeInsteadOfDescription]="true"
                      [dropdownList]="initiativeCodesList" [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Tipo Registo Imobilizado -->
                  <td *ngIf="showDistributionFixedAssetRecordType">
                    <dropdown-selector-modal formControlName="TipoRegistoImob"
                      [dropdownTitle]="'FIXED_ASSET_RECORD_TYPE_LIST'|translate" [DropDownID]="'FixedAssetRecordType'"
                      [editMode]="enableSaveButton" [displayCodeInsteadOfDescription]="true"
                      [dropdownList]="fixedAssetRecordTypesList" [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Codigo Livro Amortização -->
                  <td *ngIf="showDistributionAmortizationBookCode">
                    <dropdown-selector-modal formControlName="CodLivroAmort"
                      [dropdownTitle]="'AMORTIZATION_BOOK_CODE_LIST'|translate" [DropDownID]="'AmortizationBookCode'"
                      [editMode]="enableSaveButton" [displayCodeInsteadOfDescription]="true"
                      [dropdownList]="amortizationBookCodesList" [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Cod Grupo Contabilização -->
                  <td *ngIf="showAccountingVatGroup">
                    <mat-form-field class="allwidth"
                      [ngClass]="{ 'mat-input-invalid': !form.controls.AccountingConfigList.controls[i].controls.CodGrupoContabilizacao.errors }">
                      <input matInput formControlName="CodGrupoContabilizacao" class="no-padding-left">
                    </mat-form-field>
                  </td>

                  <!-- Tipo -->
                  <td *ngIf="showDistributionAccountingType">
                    <dropdown-selector-modal formControlName="Tipo" [dropdownTitle]="'ACCOUNT_TYPE_LIST'|translate"
                      [DropDownID]="'AccountingConfigType'" [editMode]="canChangeExpenseAccountTaxGroup"
                      (onChangeDropdown)="onChangeAccountType($event, i)" [dropdownList]="accountingTypesList"
                      [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Conta Contabilistica -->
                  <td *ngIf="showDistributionExpenseAccount && item.get('Tipo').value == 'conta'">
                    <dropdown-selector-modal formControlName="ContaGasto"
                      [dropdownTitle]="'EXPENSE_ACCOUNT_LIST'|translate" [DropDownID]="'ExpenseAccount'"
                      [displayCodeInsteadOfDescription]="true" [editMode]="canChangeExpenseAccountTaxGroup"
                      [dropdownList]="expenseAccountsList" [setDefaultValue]="false"
                      (onChangeDropdown)="onChangeExpenseAccount($event, i)">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Encargo Produto -->
                  <td *ngIf="showDistributionExpenseAccount && item.get('Tipo').value == 'encargoProduto'">
                    <dropdown-selector-modal formControlName="ContaGasto"
                      [dropdownTitle]="'PRODUCTS_CHARGES_LIST'|translate" [DropDownID]="'ProductChargeAccount'"
                      [displayCodeInsteadOfDescription]="true" [editMode]="canChangeExpenseAccountTaxGroup"
                      [dropdownList]="productChargeAccountList" [setDefaultValue]="false"
                      (onChangeDropdown)="onChangeExpenseAccount($event, i)">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Imobilizado -->
                  <td *ngIf="showDistributionExpenseAccount && item.get('Tipo').value == 'imobilizado'">
                    <dropdown-selector-modal formControlName="ContaGasto" [dropdownTitle]="'IMMOBILIZED_LIST'|translate"
                      [DropDownID]="'ImmobilizedAccount'" [displayCodeInsteadOfDescription]="true"
                      [editMode]="canChangeExpenseAccountTaxGroup" [dropdownList]="immobilizedAccountList"
                      [setDefaultValue]="false" (onChangeDropdown)="onChangeExpenseAccount($event, i)">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Produto -->
                  <td *ngIf="showDistributionExpenseAccount && item.get('Tipo').value == 'produto'">
                    <dropdown-selector-modal formControlName="ContaGasto" [dropdownTitle]="'PRODUCTS_LIST'|translate"
                      [DropDownID]="'ProductAccount'" [displayCodeInsteadOfDescription]="true"
                      [editMode]="canChangeExpenseAccountTaxGroup" [dropdownList]="productsAccountList"
                      [setDefaultValue]="false" (onChangeDropdown)="onChangeExpenseAccount($event, i)">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Recurso -->
                  <td *ngIf="showDistributionExpenseAccount && item.get('Tipo').value == 'recurso'">
                    <dropdown-selector-modal formControlName="ContaGasto" [dropdownTitle]="'RESOURCES_LIST'|translate"
                      [DropDownID]="'ResourceAccount'" [displayCodeInsteadOfDescription]="true"
                      [editMode]="canChangeExpenseAccountTaxGroup" [dropdownList]="resourcesAccountList"
                      [setDefaultValue]="false" (onChangeDropdown)="onChangeExpenseAccount($event, i)">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Método Dedução IVA -->
                  <td *ngIf="showDistributionVatTreatmentType">
                    <dropdown-selector-modal formControlName="TipoTratamentoIva"
                      [dropdownTitle]="'VAT_TREATMENT_TYPES_LIST'|translate" [DropDownID]="'VatDeductionMethod'"
                      [displayCodeInsteadOfDescription]="true" [editMode]="canChangeExpenseAccountTaxGroup"
                      [dropdownList]="vatDeductionMethodList" [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Grupo Contabilistico IVA -->
                  <td *ngIf="showDistributionVATaccountingGroup">
                    <dropdown-selector-modal formControlName="GrupoIVA"
                      [dropdownTitle]="'VAT_ACCOUNTING_GROUP_LIST'|translate" [DropDownID]="'VatGroup'"
                      [displayCodeInsteadOfDescription]="true" [editMode]="canChangeExpenseAccountTaxGroup"
                      [dropdownList]="vatGroupsList" [setDefaultValue]="false">
                    </dropdown-selector-modal>
                  </td>

                  <!-- CodMensualizacao -->
                  <td *ngIf="showDistributionCodMensualizacao">
                    <dropdown-selector-modal formControlName="CodMensualizacao"
                      [dropdownTitle]="'Lista ' + ('MONTHLY_CODE' | translate)" [DropDownID]="'MonthlyCode'"
                      [editMode]="canChangeExpenseAccountTaxGroup" [displayCodeInsteadOfDescription]="true"
                      [dropdownList]="monthlyCodesList" [setDefaultValue]="true">
                    </dropdown-selector-modal>
                  </td>

                  <!-- Observações -->
                  <td class="verticalMiddle text-center">
                    <a class="btn btn-sm no-margin-left" (click)="openNotes(i)">
                      <span [title]="'NOTES'|translate"><i class="fas fa-align-left backwhite"></i></span>
                    </a>
                  </td>

                  <td *ngIf="!isDisabled && enableSaveButton" class="text-center">
                    <button type="button" class="btn btn-sm" (click)="remove(i)">
                      <span title="{{'BUTTON.DELETE' | translate}}">
                        <i class="far fa-trash-alt color-danger backwhite"></i>
                      </span>
                    </button>

                    <button type="button" class="btn btn-sm" (click)="copy(item)">
                      <span title="{{'COPY' | translate}}">
                        <i class="far fa-clone blue backwhite"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <!--<ng-template #noResultsCostCenterConfig>
                <tr>
                  <td [colSpan]="!isDisabled ? 7 : 6" class="text-center">{{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
                </tr>
              </ng-template>-->
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>


  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button *ngIf="enableSaveButton && !isDisabled" type="button" class="btn btn-default"
        title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
        {{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="!enableSaveButton || isDisabled" type="button" class="btn btn-default"
        title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
      <button *ngIf="!isDisabled && enableSaveButton" type="button" class="btn btn-default"
        title="{{'RECALCULATE' | translate}}" (click)="recalculate()">
        {{'RECALCULATE' | translate}}
      </button>
      <button *ngIf="!isDisabled && enableSaveButton && showLoadAccountingButton" type="button" class="btn btn-default"
        title="{{'LOAD_ACCOUNTING' | translate}}" (click)="loadAccounting()">
        {{'LOAD_ACCOUNTING' | translate}}
      </button>
      <button *ngIf="!isDisabled && enableSaveButton" type="button" class="btn btn-default"
        title="{{'ADD' | translate}}" (click)="addAccountingConfig(true)">
        {{'ADD' | translate}}
      </button>
      <button *ngIf="!isDisabled && enableSaveButton" type="button" class="btn btn-primary"
        title="{{'BUTTON.SAVE' | translate}}" (click)="onSubmit()"
        [disabled]="(!changedForm && enableSavingWhenChangingForm)">
        {{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>